export enum VoucherValueType {
	ValueOnly = "ValueOnly",
	MaxValueAndPercentage = "MaxValueAndPercentage",
}
